import { defineComponent as _defineComponent } from 'vue'
import { withDefaults } from 'vue'


const __default__ = {
  inheritAttrs: false,
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Collapse',
  props: {
    value: { type: Boolean, default: false },
    title: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', val: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: boolean, title: string };




function toggleContent() {
  emit("input", !props.value);
}

function enterContent(el: Element) {
  const content = el as HTMLElement;

  content.style.height = "0px";
  content.style.opacity = "0";
  content.style.overflow = "hidden";
  content.style.transition = "height 0.2s ease, opacity 0.2s ease";

  requestAnimationFrame(() => {
    content.style.height = `${content.scrollHeight}px`;
    content.style.opacity = "1";
  });
}

function afterEnterContent(el: Element) {
  const content = el as HTMLElement;

  content.style.height = "auto";
  content.style.overflow = "visible";
}

function leaveContent(el: Element, done: () => void) {
  const content = el as HTMLElement;

  content.style.height = `${content.scrollHeight}px`;
  content.style.opacity = "1";
  content.style.overflow = "hidden";
  content.style.transition = "height 0.2s ease, opacity 0.2s ease";

  requestAnimationFrame(() => {
    content.style.height = "0px";
    content.style.opacity = "0";
  });

  window.setTimeout(done, 200);
}

return { __sfc: true,props, emit, toggleContent, enterContent, afterEnterContent, leaveContent }
}

})